import React from 'react';
import { Link } from 'react-router-dom';
import FadeIn from './FadeIn';

export default function CTASection({ 
  title = "Ready to Experience Padua?", 
  desc = "We invite you to walk the grounds, see the spaces, and understand how your celebration will flow.",
  primaryText = "Book a Private Tour",
  primaryLink = "/weddings/private-tour",
  secondaryText = "Request an Estimate",
  secondaryLink = "/weddings/investment"
}) {
  return (
    <section className="py-32 px-6 text-center max-w-4xl mx-auto border-t border-brand-stone/30">
      <FadeIn>
        <span className="text-brand-bronze uppercase tracking-[0.3em] text-[10px] font-bold mb-6 block">Take the Next Step</span>
        <h2 className="font-serif text-4xl md:text-5xl text-brand-charcoal mb-8 font-light">
          {title}
        </h2>
        <p className="font-sans text-brand-charcoal/80 text-lg font-light mb-10 max-w-2xl mx-auto">
          {desc}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
          <Link to={primaryLink} className="w-full sm:w-auto inline-block bg-brand-olive text-brand-vintage px-12 py-4.5 text-[10px] uppercase tracking-[0.25em] hover:bg-brand-charcoal transition-all font-bold shadow-xl">
            {primaryText}
          </Link>
          <Link to={secondaryLink} className="w-full sm:w-auto inline-block border border-brand-charcoal text-brand-charcoal px-12 py-4.5 text-[10px] uppercase tracking-[0.25em] hover:bg-brand-aged transition-all font-bold">
            {secondaryText}
          </Link>
        </div>
      </FadeIn>
    </section>
  );
}